import { CORRIDOR, CONVENTIONAL, MAXIMUM_HORIZONTAL_ANGLE_OF_VIEW } from 'helpers/globals'
import { ValidationError } from 'helpers/validator/validator'

export default function updateFovMode(camera, action) {
  if (camera.horizontalAngleOfView > MAXIMUM_HORIZONTAL_ANGLE_OF_VIEW && camera.fovMode === CONVENTIONAL) throw new ValidationError(`Corridor Mode is disabled at AoV greater than 180°`)
  return Object.assign({}, camera, {
    fovMode: camera.fovMode === CONVENTIONAL ? CORRIDOR : CONVENTIONAL
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateFovMode.js